import operate from './operate'
// import { prefixPath } from '@/config'
// import ButtonFile from '@/components/upload'

export default function () {
  return [
    {
      title: '姓名',
      [$field]: 'userName'
    },
    {
      title: '工号',
      [$field]: 'userCode'
    },
    {
      title: '性别',
      [$field]: 'gender',
      render: (h, {row, index}) => {
        let edit
        this.dictMap['DM14'].map(item => {
          if (row.gender == item.value) {
            edit = item.label
          }
        })
        return h('div', [edit])
      }
    },
    // {
    //   title: '出生日期',
    //   [$field]: 'birthday'
    // },
    {
      title: '政治面貌',
      [$field]: 'political',
      render: (h, {row, index}) => {
        let edit
        this.dictMap['GB4762'].map(item => {
          if (row.political == item.value) {
            edit = item.label
          }
        })
        return h('div', [edit])
      }
    },
    {
      title: '学历',
      [$field]: 'education',
      render: (h, {row, index}) => {
        let edit
        this.dictMap['DM16'].map(item => {
          if (row.education == item.value) {
            edit = item.label
          }
        })
        return h('div', [edit])
      }
    },
    {
      title: '工作地',
      [$field]: 'workPlace'
    },
    {
      title: '行政职务',
      [$field]: 'hrDuty',
      render: (h, {row, index}) => {
        let edit
        this.dictMap['KZ27'].map(item => {
          if (row.hrDuty == item.value) {
            edit = item.label
          }
        })
        return h('div', [edit])
      }
    },
    // {
    //   title: '申请类型',
    //   [$field]: 'honestType',
    //   render: (h, {row, index}) => {
    //     const honestTypeList = this.selectOptionList.map(item => {
    //       return h('Option', {
    //         props: {
    //           label: item.label,
    //           value: item.value
    //         }
    //       })
    //     })
    //     return h('Select', {
    //       props: {
    //         value: row.honestType,
    //         disabled: this.reportState == '1'
    //       },
    //       on: {
    //         'on-change': (val) => {
    //           row.honestType = val
    //           this.tableData[index].honestType = val
    //         }
    //       }
    //     }, [...honestTypeList])
    //   }
    // },
    // {
    //   title: '廉洁无问题证明文件模板',
    //   [$field]: 'fileId',
    //   render: (h, {row, index}) => {
    //     let filesDom = [
    //       h('span', {
    //         class: 'iv-pointer iv-hover-color iv-main-color',
    //         on: {
    //           click: () => {
    //             let url = `${prefixPath}file/downloadFile?fileId=${row.fileId}` + '&access_token=' + sessionStorage.getItem('token') + '&currentAuthScopeId=' + sessionStorage.getItem('listOrgId')
    //             window.open(url)
    //           }
    //         }
    //       }, row.fileName)
    //     ]
    //     filesDom.push(
    //       h(ButtonFile, {
    //         props: {
    //           accept: '.docx,.doc,.xls,.xlsx,.pdf,.jpg,.jpeg,.png,.gif,.bmp',
    //           isText: true,
    //           dynamicClass: 'iv-main-color',
    //           data: {
    //             override: true,
    //             path: '/cw',
    //             groupId: row.fileId
    //           },
    //           isShowFileList: true
    //         },
    //         on: {
    //           'on-upload-success': (file) => {
    //             let currentFile = file.response.data
    //             this.files = []
    //             this.files.push({
    //               listId: row.listId,
    //               fileId: file.response.data.fileId,
    //               fileName: file.response.data.fileName
    //             })
    //             row.fileId = currentFile.fileId
    //             row.fileName = currentFile.fileName
    //             this.tableData[index].fileId = currentFile.fileId
    //             this.tableData[index].fileName = currentFile.fileName
    //             this.$set(this.tableData, index, {...this.tableData[index], fileId: currentFile.fileId})
    //             this.$set(this.tableData, index, {...this.tableData[index], fileName: currentFile.fileName})
    //           }
    //         }
    //       })
    //     )
    //     return h('div', filesDom)
    //   }
    // },
    {
      title: '操作',
      [$field]: 'operate',
      isOperate: true,
      slotComponent: operate
    }
  ]
}
